export enum ConversationMessageType {
	MESSAGE = "MESSAGE",
	ACTION = "ACTION",
}

export enum CalendarInviteResponseType {
	ACCEPTED = "ACCEPTED",
	DECLINED = "DECLINED",
	TENTATIVE = "TENTATIVE",
}
